import type { LoginFormIds } from '@/types/forms'

export const LOGIN_FORM_ID = 'login_form'

export const LOGIN_FORM_TYPE = 'login'

export const LOGIN_EMAIL_INPUT_ID = 'login_email_input'
export const PASSWORD_INPUT_ID = 'password_input'

export const LOGIN_FORM_SUBMIT_BUTTON_ID = 'login_form_submit_button'

export const LOGIN_FORGOT_PASSWORD_BUTTON_ID = 'login_forgot_password_button'
export const LOGIN_VIEW_ACCOUNT_BUTTON_ID = 'login_view_account_button'
export const LOGIN_TWO_FACTOR_AUTH_BUTTON_ID = 'login_2fa_button'
export const LOGIN_TWO_FACTOR_AUTH_ENGAGEMENT_ACTION_ID = 'login_2fa_otp_completion_time'

export const LOGIN_FORM_FIELD_IDS = {
	email: LOGIN_EMAIL_INPUT_ID,
	password: PASSWORD_INPUT_ID,
	submit: LOGIN_FORM_SUBMIT_BUTTON_ID
} as const satisfies LoginFormIds
